import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

const CustomInput = ({
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    name,
    disabled = false,
    className = '',
    required = false,
    dataE2e,
    autoComplete,
}) => {
    const clientData = useSelector(state => state.juno.clientData);
    const { readOnly } = clientData || {};

    return (
        <div className="mt-6 w-full">
            {label && (
                <label
                    htmlFor={name}
                    className="block text-xs font-medium text-balanceCard-manage mb-2 uppercase leading-none text-left w-full">
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}
            {type == 'textarea' ? (
                <textarea
                    placeholder={placeholder?.toUpperCase()}
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    required={required}
                    className={`w-full bg-card-bg !text-text rounded-md text-sm font-medium py-2 px-3 h-12 leading-tight ${className}`}
                    disabled={readOnly}
                />
            ) : (
                <input
                    type={type}
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder?.toUpperCase()}
                    data-e2e={`${dataE2e}-${placeholder?.toUpperCase()}`}
                    autoComplete={autoComplete ??  `new-${name}`}

                    required={required}
                    className={clsx(
                        `custom-input w-full bg-card-bg !text-text rounded-md text-sm font-medium py-2 px-3 h-12 leading-tight hover:bg-transparent hover:border hover:border-[#D1D1D6] hover:dark:bg-transparent hover:dark:border-[#A0A0AB] ${className}`,
                        disabled || readOnly ? 'cursor-not-allowed' : '',
                    )}
                    disabled={readOnly || disabled}
                />
            )}
        </div>
    );
};

CustomInput.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    autoComplete: PropTypes.string,
};

export default CustomInput;
